<template>
  <!-- 录面访 弹屏 -->
  <a-modal
    v-model="isInterview"
    destroyOnClose
    :footer="null"
    :maskClosable="false"
    :closable="false"
    :width="700"
    centered
  >
    <div class="content-interview">
      <div class="title">
        <a-icon @click="isInterviewFn" style="font-size: 16px; cursor: pointer" type="close" />
        <span>录面访</span>
        <span style="font-size: 16px; color: var(--ThemeColor); cursor: pointer" @click="interviewOK">提交</span>
      </div>
      <div style="margin-top: 20px">
        <span style="margin-right: 10px; font-weight: bold">面访时间</span>
        <a-date-picker placeholder="请选择时间" :disabled-date="disabledLookDate" @change="getViewTime">
        </a-date-picker>
      </div>
      <textarea
        class="textarea"
        v-model="interviewRecordData.interviewContent"
        :maxlength="100"
        placeholder="请输入内容"
      ></textarea>

      <!--      <h4 style="font-weight: 700">面访附件</h4>-->
      <!--      <div>-->
      <!--        <a-upload :action="uploadImgUrl" :headers="headers" @change="handleChange">-->
      <!--          <a-button> <a-icon type="upload" /> 上传附件 </a-button>-->
      <!--        </a-upload>-->
      <!--      </div>-->
    </div>
  </a-modal>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import touristApi from '@/api/system/tourist/tourist.js'
import storage from 'store'

export default {
    props: {
        userId: {
            type: [Number, String],
            default: ''
        }
    },
    data () {
        return {
            isInterview: false,
            // 上传附件
            uploadImgUrl: process.env.VUE_APP_BASE_URL + '/system/oss/upload',
            headers: {
                Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN)
            },
            // 新增面访记录参数
            interviewRecordData: {
                // accessoryIds: '', // 附件IDs
                interviewContent: '', // 面访内容
                interviewTime: '', // 面访时间
                resourceId: this.userId,
                resourceType: '2',
                rentSaleType: '1' // 租售类型rent_sale_type  1租2售
            },
            ossid: []
        }
    },
    methods: {
        // 关闭面访弹窗
        isInterviewFn () {
            this.interviewRecordData.interviewContent = ''
            this.interviewRecordData.accessoryIds = '' // 附件IDs
            this.interviewRecordData.interviewTime = '' // 面访时间
            this.imgUrl = ''
            this.isInterview = false
        },
        disabledLookDate (current) {
            return current && current > this.$moment().endOf('day')
        },
        // 获取面访时间
        getViewTime (m, val) {
            this.interviewRecordData.interviewTime = val
        },
        // 面谈-上传
        async handleChange (info) {
            if (info.file.status === 'done') {
                if (info.file.response.code !== 200) {
                    this.$message.error('上传失败' + info.file.response.msg)
                    return
                }
                this.ossid = info.fileList.map((item) => {
                    return item.response.data.ossId
                })
                this.interviewRecordData.accessoryIds = this.ossid.toString()
                // console.log('ossidsd', this.interviewRecordData.accessoryIds)
            }
            if (info.file.status === 'removed') {
                this.ossid = info.fileList.map((item) => {
                    return item.response.data.ossId
                })
                this.interviewRecordData.accessoryIds = this.ossid.toString()
                // console.log('ossidsd', this.interviewRecordData.accessoryIds)
            }
        },
        // 面谈===>提交
        interviewOK () {
            this.interviewRecordAdd()
        },
        // 新增面访记录
        interviewRecordAdd () {
            this.interviewRecordData.resourceId = this.userId
            const keys = Object.keys(this.interviewRecordData)
            for (let index = 0; index < keys.length; index++) {
                if (!this.interviewRecordData[keys[index]]) {
                    this.$message.warn('您还未填写完整！')
                    return
                }
            }
            touristApi.interviewRecordAdd({ ...this.interviewRecordData }).then((res) => {
                if (res.code === 200) {
                    this.$message.success('提交面访成功')
                    // this.getRecordList()
                    // this.getUserInfo()
                    this.isInterviewFn() // 关闭面访弹窗
                    this.$emit('onSuccess')
                }
            })
        },
        open () {
            this.isInterview = true
        }
    }
}
</script>

<style lang="less" scoped>
//面访
.content-interview {
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }
  .textarea {
    margin-top: 20px;
    width: 100%;
    height: 90px;
    outline: none;
    border-radius: 10px;
    border-color: #f1f2f3;
    padding: 10px;
    margin-bottom: 20px;
    resize: none;
    overflow: hidden;
  }
  // .upload-box {
  //   width: 240px;
  //   height: 160px;
  //   border-radius: 10px;
  //   background-color: #f9f7fb;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   .upload {
  //     color: var(--ThemeColor);
  //     font-weight: 700;
  //     display: flex;
  //     flex-direction: column;
  //     align-items: center;
  //   }
  // }
}
</style>
